/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.server.defs'

type $nsid = typeof $nsid

export { $nsid }

type InviteCode = {
  $type?: 'com.atproto.server.defs#inviteCode'
  code: string
  uses: InviteCodeUse[]
  disabled: boolean
  available: number
  createdAt: l.DatetimeString
  createdBy: string
  forAccount: string
}

export type { InviteCode }

const inviteCode = /*#__PURE__*/ l.typedObject<InviteCode>(
  $nsid,
  'inviteCode',
  /*#__PURE__*/ l.object({
    code: /*#__PURE__*/ l.string(),
    uses: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.ref<InviteCodeUse>((() => inviteCodeUse) as any),
    ),
    disabled: /*#__PURE__*/ l.boolean(),
    available: /*#__PURE__*/ l.integer(),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    createdBy: /*#__PURE__*/ l.string(),
    forAccount: /*#__PURE__*/ l.string(),
  }),
)

export { inviteCode }

type InviteCodeUse = {
  $type?: 'com.atproto.server.defs#inviteCodeUse'
  usedAt: l.DatetimeString
  usedBy: l.DidString
}

export type { InviteCodeUse }

const inviteCodeUse = /*#__PURE__*/ l.typedObject<InviteCodeUse>(
  $nsid,
  'inviteCodeUse',
  /*#__PURE__*/ l.object({
    usedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    usedBy: /*#__PURE__*/ l.string({ format: 'did' }),
  }),
)

export { inviteCodeUse }
